import React from 'react';
import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import { OfferInfo } from './styles';
import svg from '../../../../static/img/external-link.svg';
import Action from '../../../../components/Section/Action';

const BoxLoyalty = () => {
  const title = 'Programa de fidelidade';
  const describeTitle = 'Benefícios exclusivos a cada nível conquistado';

  const redirectUrl = 'http://beta.fidelidade.globoplay.globo.com';
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Content>
        <Action href={redirectUrl} target="_blank" theme="link">
          <div>
            <OfferInfo>Acesse a página do programa</OfferInfo>
          </div>
          <Icon svg={svg} alt="icon-external-link" />
        </Action>
      </Content>
    </Box>
  );
};

export default BoxLoyalty;
